import React from 'react'

import { RecordEditManagerResult } from 'features/datagrid/hooks/useRecordEditManager'

export const RecordEditManagerContext = React.createContext<RecordEditManagerResult | null>(null)
